import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

import { Tabs } from '@thinknet-gmbh/platform-common-ui';
import { PageLayout } from '@thinknet-gmbh/platform-common-ui';

import { TabsWrapper } from './applications.styles';
import Eau from './applications-tabs/eau/eau.component';

const { TabPane } = Tabs;

const Applications = () => {
  const { t } = useTranslation('applications');
  const location = useLocation();

  const [, setEditData] = useState<any>(location.state?.initialData || null);

  const onCancel = () => {
    setEditData(null);
  };

  return (
    <PageLayout pageTitle={t('labels.pageTitle')}>
      <TabsWrapper>
        <Tabs onChange={onCancel} defaultActiveKey={location.state?.activeTabKey}>
          <TabPane tab={t('labels.eau')} key="1">
            <Eau />
          </TabPane>
        </Tabs>
      </TabsWrapper>
    </PageLayout>
  );
};

export default Applications;
